module.exports = __webpack_public_path__ + "img/login_bg.b37f99f6.svg";